const USER_TYPES = {
  admin: "ADMIN",
  freelancer: "FREELANCER",
  recruiter: "RECRUITER",
  partner: "PARTNER",
  showcase: "SHOWCASE",
  client: "CLIENT",
  signal: "SIGNAL",
};

const USER_TRANSITIONS = {
  showcaseToClient: "showcaseToClient",
};

const USER_TRANSITION_DEFAULTS = {
  showcaseToClient: {
    role: USER_TYPES.client,
    sendResetPasswordEmail: true,
  },
};

export { USER_TRANSITIONS, USER_TRANSITION_DEFAULTS };

export default USER_TYPES;
